<template>
  <PdfPreviewModal
    :model-value="pdfPreview.isOpen.value"
    :src="pdfPreview.previewUrl.value"
    :mime-type="pdfPreview.mimeType.value"
    :title="pdfPreview.title.value"
    :is-loading="pdfPreview.isLoading.value"
    :error-message="pdfPreview.errorMessage.value"
    @update:model-value="onUpdateModelValue"
    @download="pdfPreview.downloadPdf"
  />
</template>

<script setup lang="ts">
import PdfPreviewModal from '@/components/PdfPreviewModal.vue';
import { usePdfPreview } from '@/hooks/use-pdf-preview';

const pdfPreview = usePdfPreview();

const onUpdateModelValue = (value: boolean) => {
  if (!value) {
    pdfPreview.closePdfPreview();
  }
};
</script>
